export default __webpack_public_path__ + "static/media/4.Eruul_mend.46e830a8.png";